import React from 'react';
import { Title } from "../../atoms";
import { FaBars } from "react-icons/fa";
import { Stack } from "@mui/material";



export const OnBoardingHeader = ({bottomText = 'Sports Shops'})=>{



    return (
        <div className="appHeaderSec">
        <div className="logo-and-title nowrap space-right2">
          
          <img src={require('../../../assets/images/logo2.png')} className={"header-logo"} alt="Logo image" />
          
          <div className={`multiSec leftHeader `} >
              <Stack direction={"row"} spacing={2} className="center">
                
                  <Title className={"headerTxtUprLeft nowrap"} text={"MERCHANT ONBOARDING"} />
                
                
              </Stack>
              <Title className={"headerTxtBtmLeft nowrap"} text={bottomText} />
          </div>
          
        
        </div>
        </div>
    )
}

export default OnBoardingHeader;